// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { postWrapper } from 'helpers/api'

// NOTE - the terrain API has a flag smoothed which defaults to false.
// We do not currently have a requirement to support this.
// d is an array of coordinate objects for which the analysis engine will
// calculate their elevations.
export const calculateGroundElevations = d => postWrapper(`/terrain-services/ground-elevations`, d)
